// extracted by mini-css-extract-plugin
module.exports = {"switchWrapper":"BigFiveShareSettings_switchWrapper__2H9-b","label":"BigFiveShareSettings_label__1R97s","info":"BigFiveShareSettings_info__3jrSm"};